import { render, staticRenderFns } from "./StudentNotice.vue?vue&type=template&id=0615b11a&"
import script from "./StudentNotice.vue?vue&type=script&lang=js&"
export * from "./StudentNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports